import { c as _c } from "react/compiler-runtime";
import type { FootprintVariant } from '@onefootprint/footprint-js-legacy';
import { Layout as AppLayout } from '@onefootprint/idv';
import type React from 'react';
import { useHandoffMachine } from '../machine-provider';
type LayoutProps = {
  children: React.ReactNode;
  variant?: FootprintVariant;
};
const Layout = t0 => {
  const $ = _c(5);
  const {
    children,
    variant
  } = t0;
  const [state] = useHandoffMachine();
  const {
    onboardingConfig
  } = state.context;
  const isSandbox = onboardingConfig?.isLive === false;
  let t1;
  if ($[0] !== children || $[1] !== isSandbox || $[2] !== onboardingConfig || $[3] !== variant) {
    t1 = <AppLayout variant={variant} isSandbox={isSandbox} config={onboardingConfig}>{children}</AppLayout>;
    $[0] = children;
    $[1] = isSandbox;
    $[2] = onboardingConfig;
    $[3] = variant;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default Layout;